import { Color } from "@apis/index";
import AccessDenied from "@components/access-denied";
import { deletesvg, edit } from "@assets/icons";
import Header from "@commons/header";
import Column from "@components/column";
import DeleteModal from "@components/delete-modal";
import Table from "@components/table";
import { useModal } from "@context/ModalContext";
import { RootState } from "@store/index";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQueryState } from "@hooks/useQueryState";

const ColorList = () => {
  const {
    items: colors,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.colors);
  const [page, setPage] = useQueryState<number>("page", 1);
  const [search, setSearch] = useState("");
  const [error, setError] = useState<string | null>(null);

  const fetchColors = async () => {
    setError(null);
    try {
      await Color.list({ state: "colors", params: { limit: 30, page, search } });
    } catch (err: any) {
      console.error("Failed to fetch colors:", err);
      setError(err.message || "Failed to load colors");
    }
  };
  const { showModal } = useModal();
  useEffect(() => {
    fetchColors();
  }, [page, search]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const columns = [
    {
      title: "SN",
      key: "sn",
      render: (_item: any, index: number) => index,
    },
    {
      title: "Color Name",
      key: "name",
      render: (item) => item.name,
    },
    {
      title: "Hex Code",
      key: "code",
      render: (item) => item.code,
    },
    {
      title: "Preview",
      key: "preview",
      render: (item: any) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "4px",
              backgroundColor: item.code,
              border: "1px solid #cbd5e1",
            }}
          />
        </div>
      ),
    },
  ];
  const navigate = useNavigate();

  if (error) {
    return (
      <Column>
        <Header title="All Item Colors" />
        <AccessDenied
          message={error}
          onRetry={fetchColors}
        />
      </Column>
    );
  }

  return (
    <Column>
      <Header title="All Item Colors" />
      <Table
        columns={columns}
        data={colors}
        totalItems={totalItems}
        totalPages={totalPages}
        itemsPerPage={30}
        pageControlled={page}
        onPageChange={setPage}
        hasSearchbar={true}
        onSearchChange={setSearch}
        text="Color List"
        actions={[
          {
            key: "edit",
            icon: edit,
            onClick: (item) => {
              navigate(`/admin/product-management/colors/${item.id}`, {
                state: item,
              });
            },
          },
          {
            key: "delete",
            icon: deletesvg,
            onClick: async (item) => {
              showModal(
                <DeleteModal
                  state="colors"
                  api={Color}
                  id={item.id}
                  onSuccess={() => fetchColors()}
                />
              );
            },
          },
        ]}
      />
    </Column>
  );
};

export default ColorList;
